import {
  IPaymentCardCommonData,
  IPaymentCardMandatoryPropsForHDPass,
  PAYMENT_FORM_MODE,
} from '../models/common/payments';
import { VariantKey } from '../models/b2b/pha';

export type FormOrigin = '' | PAYMENT_FORM_MODE;

export type CreditCardFormAction =
  | {
      type: 'open';
      mode: CreditCardFormState['mode'];
      card: CreditCardFormState['card'];
      origin?: FormOrigin;
    }
  | { type: 'close' };

export type CreditCardFormState = {
  mode: PAYMENT_FORM_MODE | null;
  card: IPaymentCardCommonData | IPaymentCardMandatoryPropsForHDPass | null;
  origin: FormOrigin;
};

export function creditCardFormReducer(
  state: CreditCardFormState,
  action: CreditCardFormAction,
): CreditCardFormState {
  switch (action.type) {
    case 'open':
      return {
        ...state,
        mode: action.mode,
        card: action.card,
        origin: action.origin || '',
      };
    case 'close':
      return {
        mode: null,
        card: null,
        origin: '',
      };
    default:
      throw new Error();
  }
}

export type LocMockAction = {
  type: 'update';
  payload: Partial<LocMockState>;
};

export type LocMockState = {
  variants: VariantKey[];
  persistKey: string;
};

export function locMockReducer(
  state: LocMockState,
  action: LocMockAction,
): LocMockState {
  const { type, payload } = action;

  switch (type) {
    case 'update':
      return {
        ...state,
        ...payload,
      };
    default:
      throw new Error();
  }
}
